<div class="qr-dialog">
  <button class="close" (click)="closeClick()">X</button>
  <h2>Some error appears...</h2>
  <div class="error-message">{{data}}</div>
</div>
